import React from "react";

function Awarding({awardingData}) {

    //console.log(awardingData);

    return (
        <>
            {
                awardingData ?
                    <>
                        <h2 className="text-4xl mb-4">{awardingData.awarding_title}</h2>
                        <p>{awardingData.awarding_text}</p>
                    </> : ''
            }
        </>
    )
}

export default Awarding